function postImageURL (folderId: string, fileName: string) {
  return `${process.env.NEXT_PUBLIC_PATHWAY_API}/v1/images/${folderId}/${fileName}`
}

export default postImageURL
